import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Table, Spinner } from 'react-bootstrap';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const CardsView = ({ season }) => {
    const [yellowCards, setYellowCards] = useState([]);
    const [redCards, setRedCards] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const [yellowResponse, redResponse] = await Promise.all([
                    axios.get(`${BACKEND_URL}/tables/yellow-cards?season=${season}`),
                    axios.get(`${BACKEND_URL}/tables/red-cards?season=${season}`)
                ]);
                setYellowCards(yellowResponse.data);
                setRedCards(redResponse.data);
            } catch {
                setYellowCards([]);
                setRedCards([]);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [season]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Ładowanie...</span>
                </Spinner>
            </div>
        );
    }

    return (
        <Tabs defaultActiveKey="yellow" id="cards-tabs">
            <Tab eventKey="yellow" title={<span style={{ color: '#ffc107' }}>Żółte kartki</span>}>
                <Table striped bordered hover className="sticky-col-2" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Imię i nazwisko</th>
                            <th>Drużyna</th>
                            <th>Kartki</th>
                        </tr>
                    </thead>
                    <tbody>
                        {yellowCards.map((player, index) => (
                            <tr key={index}>
                                <td>{player.position + "."}</td>
                                <td>{player.first_name + " " + player.last_name}</td>
                                <td>{player.team_name}</td>
                                <td>{player.yellow_cards}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Tab>
            <Tab eventKey="red" title={<span style={{ color: '#dc3545' }}>Czerwone kartki</span>}>
                <Table striped bordered hover className="sticky-col-2" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Imię i nazwisko</th>
                            <th>Drużyna</th>
                            <th>Kartki</th>
                        </tr>
                    </thead>
                    <tbody>
                        {redCards.map((player, index) => (
                            <tr key={index}>
                                <td>{player.position + "."}</td>
                                <td>{player.first_name + " " + player.last_name}</td>
                                <td>{player.team_name}</td>
                                <td>{player.red_cards}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Tab>
        </Tabs>
    );
};

export default CardsView;